import React, { useState, useEffect, useRef } from "react";
import DiscountImage from "../../Images/DiscountImage.png";
import axios from "axios";
import { color } from "framer-motion";
import { useTranslation } from "react-i18next";
import { MyDomain } from "../../App";

export default function ProfilePromoCodes() {
  const { t, i18n } = useTranslation();
  const [MyWidth, setMyWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setMyWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    // Cleanup listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const user = JSON.parse(localStorage.getItem("user"));

  const [PromoData, setPromoData] = useState([]);
  const [PromoDataUsed, setPromoDataUsed] = useState([]);

  const [TheCopied, setTheCopied] = useState(null);

  const GetPromoCodes = (event) => {
    setPromoData([]);
    const data = {
      UserId: user?.userId,
    };
    axios
      .post(`${MyDomain}PromoCodes/GetPromoCodes`, data) // replace with your API URL
      .then((response) => {
        console.log(response.data);
        setPromoData(response.data.allPromoCode);
        setPromoDataUsed(response.data.promoUsedByUserId);

        const availablePromoCodes = response.data.allPromoCode.filter(
          (promo) =>
            !response.data.promoUsedByUserId.some(
              (used) => used.promoCodeId === promo.id
            )
        );
      })
      .catch((err) => {
        console.log(err.response.data);
      });
  };
  useEffect(() => {
    GetPromoCodes();
  }, []);
  // Create dynamic refs
  const timerRefs = useRef([]);
  const displayRefs = useRef([]);

  // Function to format the time remaining
  const formatTime = (time) => {
    if (time <= 0) return "0 days 0:0:0";

    const days = Math.floor(time / (1000 * 60 * 60 * 24));
    const hours = Math.floor((time / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((time / (1000 * 60)) % 60);
    const seconds = Math.floor((time / 1000) % 60);

    return `${days} ${t("profile.days")} ${t(
      "profile.and"
    )} ${hours}:${minutes}:${seconds}`;
  };

  useEffect(() => {
    const timers = PromoData?.map((cardData, index) => {
      const startDate = new Date();
      const endDate = new Date(cardData.dateEnd.split("-").reverse().join("-"));
      let remainingTime = endDate - startDate;

      if (!displayRefs.current[index]) {
        displayRefs.current[index] = React.createRef();
      }
      if (!timerRefs.current[index]) {
        timerRefs.current[index] = { current: null };
      }

      if (displayRefs.current[index].current) {
        displayRefs.current[index].current.innerText =
          formatTime(remainingTime);
      }

      timerRefs.current[index].current = setInterval(() => {
        remainingTime -= 1000;
        if (remainingTime <= 0) {
          clearInterval(timerRefs.current[index].current);
          remainingTime = 0;
        }
        if (displayRefs.current[index].current) {
          displayRefs.current[index].current.innerText =
            formatTime(remainingTime);
        }
      }, 1000);

      return timerRefs.current[index];
    });

    return () => {
      timers.forEach((timerRef) => clearInterval(timerRef.current));
    };
  }, [PromoData]);

  // Styles

  const [copied, setCopied] = useState(false);
  const textToCopy = "Hello, this is the text to copy!";

  const handleCopy = (PromoCode, PromoCodeId) => {
    setTheCopied(PromoCodeId);
    navigator.clipboard.writeText(PromoCode).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 3000); // Reset after 2 seconds
    });
  };

  return (
    <div>
      <div style={{ paddingTop: 50 }}>
        <div
          style={{
            display: "flex",
            //justifyContent: "center",
            flexDirection: "column",
            paddingLeft: MyWidth <= 1024 ? "0%" : "10%",
          }}
        >
          {PromoData.length > 0 ? (
            <div>
              {PromoData.map((PromoCode, Index) => {
                const isUsed = PromoDataUsed.some(
                  (used) => used.promoCodeId === PromoCode.id
                );
                return (
                  <div key={PromoCode.id}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        //backgroundColor: "red",
                        paddingBottom: 10,
                      }}
                    >
                      <div style={styles.couponContainer}>
                        <div style={styles.coupon}>
                          <div
                            style={{
                              ...styles.couponLeft,
                              backgroundColor: isUsed ? "#fca5a5" : "#86efac",
                            }}
                          >
                            <h2 style={styles.discount}>
                              {PromoCode.discount}% {t("profile.OFF")}
                            </h2>
                            <p style={styles.code}>
                              {t("profile.UseCode")}:{" "}
                              <strong>{PromoCode.name}</strong>
                            </p>
                          </div>
                          <div style={styles.couponRight}>
                            {isUsed ? (
                              <a>{t("profile.Used")}</a>
                            ) : (
                              <a>{t("profile.Active")}</a>
                            )}
                            <p style={styles.description}>
                              {t("profile.Getflat")}{" "}
                              <a style={{ fontWeight: "bold" }}>
                                {PromoCode.discount}%
                              </a>{" "}
                              {t("profile.offonyourpurchase")}{" "}
                              <div
                                key={Index}
                                ref={(el) =>
                                  (displayRefs.current[Index] = {
                                    current: el,
                                  })
                                }
                              ></div>
                            </p>

                            <button
                              style={styles.button}
                              onClick={() => {
                                handleCopy(PromoCode.name, PromoCode.id);
                              }}
                            >
                              {copied && PromoCode.id === TheCopied
                                ? t("profile.Copied")
                                : t("profile.CopyCode")}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <div
              style={{
                display: "flex",
                //justifyContent: "center",
                flexDirection: "column",
                paddingLeft: "10%",
              }}
            >
              <div style={{ paddingTop: 50 }}>
                <p style={{ fontWeight: 500, fontSize: 25, paddingBottom: 20 }}>
                  Promo codes
                </p>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  //backgroundColor: "red",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    //height: "calc(50vh - 55px)",
                    height: 200,
                    maxHeight: 250,
                    border: "1px dashed #a8a29e",
                    borderRadius: 10,
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                  }}
                >
                  <img
                    src={DiscountImage}
                    style={{
                      width: 60,
                      height: 60,
                    }}
                  />
                  <a style={{ fontWeight: "bold", fontSize: 20 }}>
                    You have no available promo codes.
                  </a>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
const styles = {
  couponContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    //padding: "20px",
    backgroundColor: "#f9f9f9",
    width: "100%",
  },
  coupon: {
    display: "flex",
    border: "2px dashed #ccc",
    borderRadius: "10px",
    overflow: "hidden",
    //maxWidth: "600px",
    width: "100%",
    backgroundColor: "#fff",
  },
  couponLeft: {
    flex: 1,
    padding: "20px",
    textAlign: "center",
    borderRight: "2px dashed #ccc",
  },
  discount: {
    fontSize: "2rem",
    margin: "0",
    color: "#27272a",
  },
  code: {
    fontSize: "1.2rem",
    margin: "10px 0 0",
    color: "#27272a",
  },
  couponRight: {
    flex: 2,
    padding: "20px",
    textAlign: "center",
  },
  description: {
    fontSize: "1rem",
    margin: "0 0 10px",
    color: "#666",
  },
  button: {
    padding: "10px 20px",
    fontSize: "1rem",
    color: "#fff",
    backgroundColor: "#6b21a8",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
  },
};
